import React from 'react';
import { useBranding } from '../hooks/useBranding';
import '../styles/development-banner.css';

export const DevelopmentBanner: React.FC = () => {
  const { appName } = useBranding();
  
  return (
    <>
      {/* Top Banner */}
      <div className="dev-banner">
        <div className="dev-banner-content">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <span className="dev-banner-text">
            You are connected to the <strong>{appName}</strong> DEV environment
          </span>
        </div>
      </div>
      
      {/* Border overlay */}
      <div className="dev-border"></div>
    </>
  );
};
